import apiRequest from 'lib/apiRequest';

const TIMEOUT_UNTIL_FAILURE = 30000; // 30 seconds

export enum MergingUserPollStatus {
  pending = 'pending',
  complete = 'complete',
  failed = 'failed',
}

export interface MergingUserPollResponse {
  status: MergingUserPollStatus;
  status_endpoint?: string;
  retry_after?: number;
}

export async function mergingUserPoll(endpoint: string): Promise<void> {
  return new Promise((resolve, reject) => {
    let currentTimeout: ReturnType<any> | undefined;

    const onSuccess = ({ status }: MergingUserPollResponse) => {
      if (status === MergingUserPollStatus.pending) {
        currentTimeout = setTimeout(poll, 1000);
      } else if (status === MergingUserPollStatus.complete) {
        resolve();
      } else {
        reject();
      }
    };

    const poll = () => {
      apiRequest(endpoint)
        .then(onSuccess)
        .catch(err => reject(err));
    };

    poll();
    setTimeout(() => {
      clearTimeout(currentTimeout);
      reject();
    }, TIMEOUT_UNTIL_FAILURE);
  });
}
